export default __webpack_public_path__ + "static/media/Gesteira.230f9b98.png";